import { FormControl, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { text } from '~/modules/@shared/helpers/text';
import { TakePaymentFormData } from '~/modules/payment/components/TakePayment/helpers/TakePaymentSchema';

export default function PaymentDescriptionField() {
  const {
    control,
    formState: { errors },
  } = useFormContext<TakePaymentFormData>();

  return (
    <Controller
      control={control}
      name="description"
      render={({ field: { value, ...field } }) => (
        <FormControl fullWidth>
          <TextField
            {...field}
            value={value ?? ''}
            multiline
            rows={6}
            InputProps={{
              inputProps: {
                maxLength: 250,
              },
            }}
            error={!!errors.description}
            helperText={text(errors.description?.message)}
            FormHelperTextProps={{ error: true }}
          />
        </FormControl>
      )}
    />
  );
}
